<template>
  <DetailCard id="detail-ehr-general">
    <template #heading>
      <span class="pi pi-house-fill"></span>
      <a :href="getEhrGeneralExternalUrl" target="_blank">
        {{ $t(`messages.detail.ehrGeneral.title`) }}
      </a>
    </template>

    <div class="grid grid-cols-2 gap-y-3 *:pt-3 *:border-gray-200 [&>*:nth-child(n+3)]:border-t last:pb-3">
      <template
        v-for="field in FIELDS"
      >
        <label :for="field" class="font-bold px-4 border-gray-200 dark:border-gray-700">
          {{ $t(`messages.detail.ehrGeneral.${field}`) }}
        </label>
        <span class="px-4">{{ ehrGeneral[field] }}</span>
      </template>
    </div>
  </DetailCard>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useDetailStore } from '@/stores/useDetailStore'
import DetailCard from '../DetailCard.vue'

const FIELDS = [
  'ehitise-liik',
  'ehitise-nimetus',
  'ehrkood',
  'kasutuselevotu-aasta',
  'kavandatav-kasutuselevotu-kuupev',
  'ehitise-seisund',
  'peamine-kasutusotstarve',
  'ehitise-koha-aadress',
  'korterite-arv',
  'energiaklass',
  'energiaklass-kuupaev',
  'energiaklass-tohususarv',
  'energiaklass-kuupaev-lopp',
  'energiaklass-dokumendi-nr',
  'energiaklass-dokumendi-liik',
]

const store = useDetailStore()
const { ehrGeneral, ehrId } = storeToRefs(store)

const getEhrGeneralExternalUrl = computed(() => {
  return `https://ehr.ee/app/link/b/${ehrId.value}`
})
</script>